import type { TopicListItem } from '../components/session/TopicListPanel';

export interface GroupedTopics {
  completed: TopicListItem[];
  uncovered: TopicListItem[];
}

/**
 * Partitions topics into completed (taught) and uncovered, and orders the uncovered
 * list so overdue/soonest-due topics come first. Undated topics are listed after all
 * dated ones, in their original (curriculum) order. Ascending ISO-date-string comparison
 * on its own already yields overdue-before-today-before-future ordering — no separate
 * "today" reference point is needed.
 */
export function groupAndSortTopics(topics: TopicListItem[]): GroupedTopics {
  const completed: TopicListItem[] = [];
  const uncovered: TopicListItem[] = [];

  topics.forEach((topic) => (topic.isTaught ? completed : uncovered).push(topic));

  const dated = uncovered.filter((t) => !!t.scheduledDate);
  const undated = uncovered.filter((t) => !t.scheduledDate);
  dated.sort((a, b) => (a.scheduledDate! < b.scheduledDate! ? -1 : a.scheduledDate! > b.scheduledDate! ? 1 : 0));

  return { completed, uncovered: [...dated, ...undated] };
}
